import React, { useState, useEffect } from 'react';
import Logo from '../../assets/Siast-Logo.png';
import { Link, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';  // Corrected import

const Navbar = ({ isAuthenticated, handleLogout }) => {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);  // State for mobile menu

  // Decode JWT token to extract user info
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      const decodedToken = jwtDecode(token);  // Corrected function name
      setUser(decodedToken.user);  // Store user info in state
    }
  }, [isAuthenticated]);

  // Toggle the dropdown
  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
  };

  // Toggle mobile menu visibility
  const toggleMobileMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  // Close the dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('#profile-dropdown') === null) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Get the initials of the user (for profile picture fallback)
  const getInitials = (name) => {
    const nameParts = name.split(' ');
    const initials = nameParts.length > 1 ? nameParts[0][0] + nameParts[1][0] : nameParts[0][0];
    return initials.toUpperCase();
  };

  return (
    <header>
      <nav
        className="flex flex-wrap items-center justify-between w-full py-0 md:py-0 px-4 text-lg text-gray-700 bg-white relative z-50 shadow-md"
      >
        <div className="py-1">
          <Link to="/" className="flex items-center">
            <img src={Logo} alt="EBS Transliteration Logo" width="120" height={16} />
            <h5 className="text-s font-bold md:text-lg lg:text-3xl pb-1">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-sky-400 to-emerald-600 text-2xl font-extrabold pt-0">
                Translation
              </span>
            </h5>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="menu-button"
          onClick={toggleMobileMenu}  // Toggle mobile menu visibility
          className="h-6 w-6 cursor-pointer md:hidden block"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>

        {/* Mobile Menu */}
        <div
          id="menu"
          className={`w-full md:flex md:items-center md:w-auto ${menuOpen ? '' : 'hidden'}`}  // Show menu if menuOpen is true
        >
          <ul className="text-base text-gray-700 md:flex md:items-center md:pt-0 md:space-x-4">
            <li>
              <Link
                to="/"
                className={`font-bold text-sm tracking-widest md:p-4 py-2 block hover:text-blue-600 ${location.pathname === '/' ? 'text-green-700' : ''}`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/tasks"
                className={`font-bold text-sm tracking-widest md:p-4 py-2 block hover:text-blue-600 ${location.pathname === '/tasks' ? 'text-green-700' : ''}`}
              >
                Stories
              </Link>
            </li>
            <li>
              <Link
                to="/contactus"
                className={`font-bold text-sm tracking-widest md:p-4 py-2 block hover:text-blue-600 ${location.pathname === '/contactus' ? 'text-green-700' : ''}`}
              >
                Contact us
              </Link>
            </li>

            {isAuthenticated && user && (
              <li className="relative" id="profile-dropdown">
                {/* User avatar or initials */}
                <button
                  onClick={toggleDropdown}
                  className="flex items-center space-x-2 font-bold text-sm tracking-widest md:p-4 py-2 text-gray-700 hover:text-blue-600"
                >
                  {/* Avatar or initials */}
                  {user.profileImage ? (
                    <img
                      src={user.profileImage} 
                      alt="User Avatar"
                      className="w-8 h-8 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs">
                      {getInitials(user.name)}
                    </div>
                  )}
                  <span>{user.name}</span>
                </button>

                {/* Dropdown menu */}
                {dropdownOpen && (
                  <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg border border-gray-200 overflow-hidden">
                    <div className="px-4 py-2 text-gray-800 break-all">
                      {/* <p><strong>Name:</strong> {user.name}</p>
                      <p><strong>Phone:</strong> {user.phone}</p> */}
                      <p><strong>Email:</strong> {user.email}</p>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="w-full text-red-600 hover:text-red-800 px-4 py-2 text-left"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </li>
            )}

            {/* {isAuthenticated && (
              <li>
                <button
                  onClick={handleLogout}
                  className="font-bold text-sm tracking-widest md:p-4 py-2 block text-red-600 hover:text-red-800"
                >
                  Logout
                </button>
              </li>
            )} */}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
